exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2GTI1g9ZRpvjhsJLSHFOwp{color:\"[theme:neutralPrimary, default:#333333]\"}html[dir] ._2GTI1g9ZRpvjhsJLSHFOwp{border:1px solid \"[theme:neutralLight, default:#eaeaea]\";margin-top:13px;padding-top:14px;background:\"[theme:white, default:#ffffff]\"}html[dir=ltr] ._2GTI1g9ZRpvjhsJLSHFOwp{margin-right:20px}html[dir=rtl] ._2GTI1g9ZRpvjhsJLSHFOwp{margin-left:20px}", ""]);
// Exports
exports.locals = {
	"container": "_2GTI1g9ZRpvjhsJLSHFOwp"
};